import { render, staticRenderFns } from "./CollectorDetail.vue?vue&type=template&id=7f6c6f90&scoped=true&"
import script from "./CollectorDetail.vue?vue&type=script&lang=js&"
export * from "./CollectorDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6c6f90",
  null
  
)

export default component.exports